"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
const fetch = (...args) => {
    return globalThis.fetch(...args);
};
exports.fetch = fetch;
//# sourceMappingURL=fetch.js.map